module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MHpdfe/tc-custom/9781488093784.jpg?1728396466559",
      "alt": "This image is the cover for the book Bachelor's Baby Surprise, Wilde Hearts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bachelor's Baby Surprise, Wilde Hearts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Okay, Evangeline Holly!  You. Can. Do. This.  Put that bad breakup behind you. And stop obsessing over the subsequent superhot one-night stand. Focus on your future. It’s the first day of your new job! Just ignore the fact that your boss, Ryan Wilde, was your former one-night lover. (He’s so hot!) Oh, and—surprise!—you’re pregnant with Ryan’s baby. And your job hinges on keeping it secret. You’ve got this! Right?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Teri Wilson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today Bestselling Author Teri Wilson writes heartwarming romance with a touch of whimsy. Three of Teri's books have been adapted into Hallmark Channel Original Movies, including UNLEASHING MR. DARCY (plus its sequel MARRYING MR. DARCY), THE ART OF US and NORTHERN LIGHTS OF CHRISTMAS, based on her book SLEIGH BELL SWEETHEARTS. She is also a recipient of the prestigious RITA Award for excellence in romantic fiction for her novel THE BACHELOR'S BABY SURPRISE.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0